"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = exports.OPTION_INSTRUMENT_TYPE = void 0;
const types_1 = require("@refinitiv-data/types");
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const financial_contracts_1 = require("../financial-contracts");
const table_builder_1 = require("../table-builder");
exports.OPTION_INSTRUMENT_TYPE = 'Option';
function Definition(params) {
    let instrument;
    let instrumentParams;
    const tableBuilder = new table_builder_1.TableBuilderImp();
    if ((0, lodash_functions_1.isString)(params)) {
        instrument = {
            instrumentType: exports.OPTION_INSTRUMENT_TYPE,
            instrumentDefinition: { instrumentCode: params, underlyingType: types_1.IPA.FinancialContracts.Option.UnderlyingType.Eti },
        };
    }
    else {
        const { outputs, fields, extendedParams, pricingParameters } = params, paramsDefinition = __rest(params, ["outputs", "fields", "extendedParams", "pricingParameters"]);
        instrument = { instrumentType: exports.OPTION_INSTRUMENT_TYPE, instrumentDefinition: Object.assign({}, paramsDefinition), pricingParameters };
        instrumentParams = { fields, outputs, extendedParams };
    }
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const financialContracts = new financial_contracts_1.FinancialContractsProvider(session, tableBuilder);
            return financialContracts.getInstrumentAnalytics([instrument], instrumentParams);
        },
        /** @internal */
        getInstrument() {
            return instrument;
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9maW5hbmNpYWwtY29udHJhY3RzL29wdGlvbi9kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEsaURBQXlGO0FBRXpGLHdFQUE2RDtBQUM3RCx5RUFBaUU7QUFDakUsZ0VBQW9FO0FBQ3BFLG9EQUFtRDtBQUV0QyxRQUFBLHNCQUFzQixHQUFHLFFBQVEsQ0FBQztBQVEvQyxTQUFnQixVQUFVLENBQ3RCLE1BQXFEO0lBRXJELElBQUksVUFBNkQsQ0FBQztJQUNsRSxJQUFJLGdCQUE4RSxDQUFDO0lBQ25GLE1BQU0sWUFBWSxHQUFHLElBQUksK0JBQWUsRUFBRSxDQUFDO0lBRTNDLElBQUksSUFBQSwyQkFBUSxFQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUM7UUFDbkIsVUFBVSxHQUFHO1lBQ1QsY0FBYyxFQUFFLDhCQUFzQjtZQUN0QyxvQkFBb0IsRUFBRSxFQUFFLGNBQWMsRUFBRSxNQUFNLEVBQUUsY0FBYyxFQUFFLFdBQUcsQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLENBQUMsY0FBYyxDQUFDLEdBQUcsRUFBRTtTQUNySCxDQUFDO0lBQ04sQ0FBQztTQUFNLENBQUM7UUFDSixNQUFNLEVBQUUsT0FBTyxFQUFFLE1BQU0sRUFBRSxjQUFjLEVBQUUsaUJBQWlCLEtBQTBCLE1BQU0sRUFBM0IsZ0JBQWdCLFVBQUssTUFBTSxFQUFwRiw0REFBMkUsQ0FBUyxDQUFDO1FBRTNGLFVBQVUsR0FBRyxFQUFFLGNBQWMsRUFBRSw4QkFBc0IsRUFBRSxvQkFBb0Isb0JBQU8sZ0JBQWdCLENBQUUsRUFBRSxpQkFBaUIsRUFBRSxDQUFDO1FBQzFILGdCQUFnQixHQUFHLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxjQUFjLEVBQUUsQ0FBQztJQUMzRCxDQUFDO0lBRUQsT0FBTztRQUNILE9BQU8sQ0FBQyxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFDbkMsTUFBTSxrQkFBa0IsR0FBRyxJQUFJLGdEQUEwQixDQUFDLE9BQU8sRUFBRSxZQUFZLENBQUMsQ0FBQztZQUVqRixPQUFPLGtCQUFrQixDQUFDLHNCQUFzQixDQUFDLENBQUMsVUFBVSxDQUFDLEVBQUUsZ0JBQWdCLENBQUMsQ0FBQztRQUNyRixDQUFDO1FBQ0QsZ0JBQWdCO1FBQ2hCLGFBQWE7WUFDVCxPQUFPLFVBQVUsQ0FBQztRQUN0QixDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUE5QkQsZ0NBOEJDIn0=